import { Grid, useTheme } from '@mui/material';
import BookButton from './BookButton';

const PurchaseButtons = ({
  canBuy,
  canBook,
  canBookNoRef,
  cancelationFee,
  clickedBuyButton,
  index,
  loading,
  screenSize,
  handleCancelableBuy,
  handleCancelable,
  handleNoCancelableBuy,
  handleNoCancelable,
  hotelCancelationFeeError,
  validationError,
}) => {
  const theme = useTheme();

  const isCancelable = Boolean(cancelationFee?.CanBeCanceled);
  const hasCancelationInfo = cancelationFee?.CanBeCanceled !== undefined;

  // Estados claros
  const missingCancelationInfo = !hasCancelationInfo; // no hay información de cancelación
  const blockedByCancelationPolicy = isCancelable ? !canBook : !canBookNoRef; // política bloquea reserva
  const hasError = hotelCancelationFeeError || validationError;

  // Deshabilitados
  const disabledBuy = hasError || missingCancelationInfo || !canBuy;
  const disabledBook =
    hasError || blockedByCancelationPolicy || missingCancelationInfo;

  return (
    <Grid
      sx={{
        display: 'flex',
        gap: { xs: '0px', sm: '15px' },
        width: { xs: '60%', sm: '80%' },
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'center', sm: 'stretch' },
        marginBottom: { xs: '8px', sm: 0 },
      }}
    >
      <BookButton
        handleClick={isCancelable ? handleCancelableBuy : handleNoCancelableBuy}
        index={index}
        label="Comprar"
        color="#FFFFFF"
        backgroundColor="#03C868"
        disabled={disabledBuy}
        canBuy={!disabledBuy}
        tooltipText="compra"
        loading={loading}
        screenSize={screenSize}
        clickedBuyButton={clickedBuyButton.current}
        variant="buy"
        width="95%"
      />
      <BookButton
        handleClick={isCancelable ? handleCancelable : handleNoCancelable}
        index={index}
        label="Reservar"
        color={theme.text1}
        backgroundColor={theme.primary}
        disabled={disabledBook}
        canBuy={!disabledBook}
        tooltipText="reserva"
        loading={loading}
        screenSize={screenSize}
        clickedBuyButton={!clickedBuyButton.current}
        variant="reserve"
        width="95%"
      />
    </Grid>
  );
};

export default PurchaseButtons;
